import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_matching.filter_row.work_preferences');

export const REMOTE_CANDIDATES_ANY = 'any';

export type RemoteCandidatesValue = 'local_only' | 'both' | 'remote_only';

export const REMOTE_CANDIDATES_OPTIONS: Array<{
  label: string;
  value: string;
}> = [
  { label: t('location_match_values.any'), value: REMOTE_CANDIDATES_ANY },
  { label: t('location_match_values.local_only'), value: 'local_only' },
  { label: t('location_match_values.both'), value: 'both' },
  { label: t('location_match_values.remote_only'), value: 'remote_only' },
];

export const remoteCandidatesLabel = (value: string): string =>
  REMOTE_CANDIDATES_OPTIONS.find((option) => option.value === value)?.label ??
  value;
